/*
 * @Author: ylq
 * @Date: 2022-09-20 16:24:20
 * @Desc: user Store
 * @Last Modified by: ylq
 * @Last Modified time: 2025-03-19 15:17:37
 */
import { defineStore } from 'pinia';
import { clearToken } from '@/utils/auth';
import { userService } from '@/api/';
import { objectRoleEnum } from '@/utils/const';
import { extractFhAiPointsGrayscale } from '@/utils/fh-ai-points.mjs';
import { useGrayscaleStore } from '@/store';
const useUserStore = defineStore('user', {
  state: () => ({
    userInfo: undefined,
    grayscale: {} //灰度信息
  }),

  actions: {
    async getUserinfo() {
      const res = await userService.getUserInfo();
      if (!res.error) {
        // 用户信息接口里如果已经带了 Layout:aiPoints，先落到 userStore，列表渲染会直接读取这里。
        this.grayscale = extractFhAiPointsGrayscale(res.result || {});
        let menuRes = {};
        const json = await userService.checkTemplateInit();
        const checkInit = json?.result;
        // 1-未初始化 2-初始化中 3-初始化完成 4-初始化失败
        if (checkInit == 3) {
          menuRes = await userService.getUserResource();
          const useGrayScale = useGrayscaleStore(); //租户灰度
          await useGrayScale.getGrayScale();
          // Layout:aiPoints 实际来自租户灰度接口，这里同步回 userStore，避免列表只读用户信息时拿不到灰度值。
          this.grayscale = extractFhAiPointsGrayscale({
            grayscale: useGrayScale.grayList
          });
        }
        const _roles = []; //新的权限数组 默认有自定义权限主菜单
        const mRes = menuRes?.result;
        // 2024-09-09 ylq 处理路由权限，找第一个有权限的菜单；
        // 先把menuVos打平
        const menuVos = mRes?.menuVos || [];
        const menuVosFlat = [];
        menuVos.forEach((ele) => {
          if (ele.group) {
            ele.child?.length ? menuVosFlat.push(...ele.child) : '';
          } else {
            menuVosFlat.push(ele);
          }
        });
        let firstMenuRole = '';
        const checkRole = (role, type) => ((type == '10' || type == '20') && mRes.entityResources.find((el) => el.code == role)) || (type == '30' && mRes.builtIns.find((el) => el.code == role));
        for (let index = 0; index < menuVosFlat.length; index++) {
          const el = menuVosFlat[index];
          //如果是外链的话就跳过 因为外链可能有新页面打开，这里不做处理
          if (el?.type == 40) continue;
          if (el?.type == '10') {
            firstMenuRole = objectRoleEnum[el.business];
          } else {
            firstMenuRole = el.business;
          }
          console.log(500000, firstMenuRole);
          if (checkRole(firstMenuRole, el?.type)) {
            break;
          }
        }
        console.log(5959595959, 3, firstMenuRole);
        // 2024-09-09 ylq 处理路由权限，找第一个有权限的菜单；
        // 类别的menu
        const menuObj = {};
        // 处理路由顺序
        // const builtPrefix = mRes?.builtIns?.filter((el) => el.isTopping) || [];
        // const builtSuffix = mRes?.builtIns?.filter((el) => !el.isTopping) || [];
        const routerSort = mRes && menuRes.result.entityResources && (menuRes.result.entityResources = menuRes.result?.entityResources?.filter((el) => el.children?.length));
        // 排序
        const sortFn = (a, b) => parseInt(a.sort) - parseInt(b.sort);
        // 组合1
        if (mRes?.builtIns?.length) {
          mRes?.builtIns?.forEach((item) => {
            if (item?.children?.length) {
              const sub = item?.children?.sort(sortFn);
              console.log(3900000, sub);
              const curRoles = [item?.code];
              sub?.forEach((ic) => {
                curRoles.push(ic?.code);
              });
              if (item?.code == firstMenuRole) {
                _roles.unshift(...curRoles);
              } else {
                _roles.push(...curRoles);
              }
            }
          });
        }
        // 组合2
        if (routerSort?.length) {
          const rs = routerSort.sort(sortFn);
          rs.forEach((item) => {
            if (item?.children?.length) {
              const sub = item?.children.sort(sortFn);
              const curRoles = [item?.code];
              sub?.forEach((ic) => {
                curRoles.push(ic?.code);
                menuObj[ic?.code] = item?.title + (ic?.code?.indexOf(':view') === -1 ? '-' + ic?.title : '');
              });
              if (item?.code == firstMenuRole) {
                _roles.unshift(...curRoles);
              } else {
                _roles.push(...curRoles);
              }
              menuObj[item?.code] = item?.resource?.title;
            }
          });
        }
        // 组合3
        // if (builtSuffix?.length) {
        //   builtSuffix.forEach((item) => {
        //     if (item?.children?.length) {
        //       const sub = item?.children.sort(sortFn);
        //       _roles.push(item?.code);
        //       sub.forEach((ic) => {
        //         _roles.push(ic?.code);
        //       });
        //     }
        //   });
        // }

        // if (mRes?.entityResources && mRes?.entityResources.length > 0) {
        //   menuRes.result.entityResources = menuRes.result.entityResources.filter((el) => el.children?.length);
        //   menuRes.result.entityResources.forEach((item) => {
        //     if (item?.children && item?.children.length > 0) {
        //       _roles.push(item?.code);
        //       item?.children?.forEach((irc) => {
        //         _roles.push(irc?.code);
        //         menuObj[irc?.code] = item?.title + (irc?.code?.indexOf(':view') === -1 ? '-' + irc?.title : '');
        //       });
        //       menuObj[item?.code] = item?.resource?.title;
        //     }
        //   });
        // }

        // if (mRes?.builtIns && mRes?.builtIns.length > 0) {
        //   mRes?.builtIns.forEach((item) => {
        //     if (item?.children?.length > 0) {
        //       _roles.push(item?.code);
        //       item.children.forEach((ic) => {
        //         _roles.push(ic?.code);
        //       });
        //     }
        //   });
        // }
        console.log('595959595', 1777, '_roles', _roles);
        const o = { ...res.result, roles: _roles, menus: mRes, menuVosFlat, menuObj, checkInit };
        // console.log(51, import.meta, import.meta.env.MODE, import.meta.env.MODE === 'dev');
        // 开发环境
        if (import.meta.env?.MODE === 'dev') {
          // o.roles = o.roles.concat('test');
          // , 'leads-sea', 'client-manage', 'client-sea'
          // o.roles = o.roles.concat('dashboard', 'test', 'chatgpt-manage');
          // // 增加日历模块相关权限
          // o.roles = o.roles.concat('calendar', 'calendar-manage');
          // // 增加线索模块相关权限
          // o.roles = o.roles.concat('leads', 'leads-list', 'leads-sea');
          // // 增加chatgpt模块相关权限
          // o.roles = o.roles.concat('chatgpt', 'chatgpt-manage', 'setting-org-depart', 'set-leads', 'set-call');
          // // 增加设置模块相关权限
          // o.roles = o.roles.concat('setting', 'setting-org', 'setting-org-roles', 'setting-obj', 'setting-obj-system', 'setting-obj-global');
          // // 增加数据分析模块相关权限 'data-analysis-leads',
          // o.roles = o.roles.concat('data-analysis', 'data-analysis-leads-index', 'data-analysis-leads-portrait', 'data-analysis-leads-top');
        }
        // test环境 把一些前端的组件放出来
        if (import.meta.env?.MODE === 'dev') {
          o.roles = o.roles.concat('test');
        }
        // 判断是否有chatgpt 如果没有的话，加上这个权限
        // if (o.roles.indexOf('chatgpt') === -1) {
        //   o.roles = o.roles.concat('chatgpt');
        // }
        if (o.roles.indexOf('workbench') === -1) {
          // o.roles = o.roles.concat('workbench');
          // o.roles = o.roles.concat('workbench:workbench');
        }
        // 和风一样定制化 orgId=26
        // if (o.orgId === mcnDemoOrgId) {
        //   o.roles = o.roles.concat('clue');
        // }
        // 智书企飞定制化 orgId=3
        if (o.orgId === 3 && o.roles?.length) {
          o.roles = o.roles.concat('customer-sales');
        }
        // 华映资本385租户定制化 orgId=385
        if (o.orgId === 385 && o.roles?.length) {
          o.roles = o.roles.concat('hy-leads');
        }
        //
        // 默认加销售列表权限
        // if (o.roles.indexOf('leads-list') === -1) {
        //   o.roles = o.roles.concat('leads-list');
        // }
        // // 这里是销售线索默认的一些操作权限
        // o.roles = o.roles.concat('clue:add', '001001002', 'clue:import', '001001004', 'clue:transfer', 'clue:addFollow', 'clue:calling', 'clue:edit', 'customer:addSchedule');
        // 日程
        // if (o.roles.indexOf('calendar') === -1) {
        //   o.roles = o.roles.concat('calendar');
        // }
        // 判断权限是否只是自己
        const isAll = o.permission?.some((el) => el === 1 || el === 3 || el === 0);
        o.isAll = isAll;
        this.userInfo = o;
      } else {
        console.log(28, res);
      }
    },
    // 退出
    async logout() {
      await userService.logout();
      clearToken();
      window.location.href = '/login';
      // router.push({ name: 'login' });
      // this.$reset();
    }
  }
});

export default useUserStore;
